import { Logger } from '@tools/logger/logger';
import { requestsMixin } from '@tools/requests-mixin';
import { translationMixin } from '@elements/translation';
import { URL_INBOX } from '@tools/routes/routes';
import { messagingMixins } from '@pages/inbox/mixins';

export const baseXhrRequestMixin = {
  mixins: [ messagingMixins, translationMixin, requestsMixin ],
  methods: {
    async get(url, params) {
      let response = null;
      try {
        response = await this.get(url, {
          params,
        });
      } catch (error) {
        Logger.error(error);
        if (error.body.errors && error.body.errors.length) {
          Object.keys(error.body.errors).forEach((key) => this.setFormError(key, error.body.errors[key]));
        } else {
          this.emitFlashbagGlobalError();
        }
      }
      return response;
    },
    commonMenuActionsPostXhrRequest(response, dealId, action) {
      if (response && response.data) {
        this.closeInboxItemDropdown(dealId);
        this.emitFlashbagSuccessMessage(
          this.trans(`user.inbox.flashbag.success.${action}`),
        );
        this.hideAction();
      }
    },
    getMessages(unread, archived, page, search, addressIds, statusCodes, alreadyListed) {
      const data = {};

      if (search !== '') {
        data.search = search;
      }

      if (addressIds !== '') {
        data.addresses = addressIds;
      }

      if (statusCodes !== '') {
        data.statuses = statusCodes;
      }

      if (unread !== '') {
        data.unread = unread;
      }

      if (archived !== '') {
        data.archived = archived;
      }

      if (alreadyListed.length) {
        data.alreadyListed = alreadyListed.join(',');
      }

      const endpoint = URL_INBOX.replace('{page}', page);

      return this.post(endpoint, data, { emulateJSON: false })
        .then((response) => response.data);
    },
  },
};
